import { useEffect } from "react";

/**
 * Detects clicks outside a referenced element and triggers a callback,
 * with optional exclusion of specific elements.
 *
 * Useful for closing popovers, modals, or dropdowns while ignoring
 * clicks on designated trigger elements.
 */
export function useSelectiveClickOutside({ enabled, containerRef, ignoreSelector, onOutside }) {
  useEffect(() => {
    if (!enabled) return;

    const handler = (event) => {
      const el = containerRef.current;
      if (!el) return;
      if (el.contains(event.target)) return;

      if (ignoreSelector) {
        const ignored = event.target.closest(ignoreSelector);
        if (ignored) return;
      }
      onOutside();
    };

    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [enabled, containerRef, ignoreSelector, onOutside]);
}